import { render, staticRenderFns } from "./userAppointmentInfo.vue?vue&type=template&id=3e812f9c&scoped=true&"
import script from "./userAppointmentInfo.vue?vue&type=script&lang=js&"
export * from "./userAppointmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e812f9c",
  null
  
)

export default component.exports